<template>
  <div
    class="p-3 bg-white card multisteps-form__panel border-radius-xl"
    data-animation="FadeIn"
  >
    <h5 class="font-weight-bolder">Informações do {{$parent.produto.tipo_produto == 'normal' ? 'Produto' : 'Pizza'}}</h5>
    <div class="multisteps-form__content">
      <div class="mt-3 row">
        <div class="col-12 col-sm-3" v-if="$parent.produto.tipo_produto == 'normal'">
          <label>Nome *</label>
          <input
            class="multisteps-form__input form-control"
            type="text"
            placeholder="Lanche"
            v-model="$parent.produto.nome_produto"
          />
        </div>
        <div class="col-12 col-sm-3">
          <label>Categoria *</label>
          <select
            id="choices-category"
            class="form-control"
            name="choices-category"
          >
            <!-- <option v-for="(categoria,index) in categorias" :key="index" :value="categoria.produto_categoria_id"
             :selected="$parent.produto.produto_categoria_id == categoria.produto_categoria_id"
             >{{ categoria.nome }}</option> -->
          </select>
        </div>
        <div class="col-12 col-sm-3">
          <label>Impressora *</label>
          <select
            id="print"
            class="form-control"
            name="print"
          >
            <!-- <option v-for="(categoria,index) in categorias" :key="index" :value="categoria.produto_categoria_id"
             :selected="$parent.produto.produto_categoria_id == categoria.produto_categoria_id"
             >{{ categoria.nome }}</option> -->
          </select>
        </div>
        <div class="col-12 col-sm-3" v-if="$parent.produto.tipo_produto == 'normal'">
          <label>Serve quantas pessoas? *</label>
          <input
            class="multisteps-form__input form-control"
            type="text"
            placeholder="Lanche"
            v-model="$parent.produto.serve_quantidade_pessoas"
          />
        </div>
        <div class="col-12 col-sm-3 " v-if="false">
          <label>Catalogo Ifood</label>
          <select
            id="choices-catalogo-ifood"
            class="form-control"
            name="choices-catalogo-ifood"
            v-model="$parent.produto.catalog_id"
          >
            <!-- <option v-for="(categoria,index) in categorias" :key="index" :value="categoria.produto_categoria_id"
             :selected="$parent.produto.produto_categoria_id == categoria.produto_categoria_id"
             >{{ categoria.nome }}</option> -->
          </select>
        </div>
      </div>
      <div class="row" v-if="$parent.produto.tipo_produto == 'normal'">
        <div class="col-12">
          <label class="mt-4">Descrição</label>
          <p class="text-xs form-text text-muted ms-1 d-inline"></p>
          <div id="edit-description" class="h-50" :content="this.$parent.produto.descricao">

          </div>
        </div>
      </div>
      <div class="mt-4 button-row d-flex col-12">
        <soft-button
          type="button"
          color="dark"
          variant="gradient"
          class="mb-0 ms-auto js-btn-next"
          title="Next"
          v-on:click="this.$parent.nextStep"
          >Próximo</soft-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Quill from 'quill';
import Choices from "choices.js";
import SoftButton from "@/novocomponents/SoftButton.vue";

	// importa o store
	import store from '@/store'
export default {
  name: "ProductInfo",
  components: {
    SoftButton,
  },

  data: () => ({
    categorias:[],
    dispositivos:[],
    quill:null,
    descricao:'',
    dataReady:false,
    pendingProduto:null,
    ch_cate:null,
    ch_print:null
  }),

  async mounted() {
    await this.init()
    if (document.getElementById("edit-description")) {
      // eslint-disable-next-line no-unused-vars
      this.quill = new Quill("#edit-description", {
        theme: "snow",
        contentType:'html'
      });

      this.quill.on('text-change', ()=>{
        this.descricao = (document.getElementsByClassName("ql-editor")[0].innerHTML);
      });
    }

    if (document.getElementById("tipo_produto")) {
      let element = document.getElementById("tipo_produto");
      new Choices(element, {
        searchEnabled: false,
      });
    }
  },
  watch: {
    descricao(newQuestion) {
      this.$parent.produto.descricao = newQuestion
    },
  },
  methods: {
    buildCatChoices(selectedCatId){
      return this.categorias.map(function(cat){
        return {
          value: String(cat.produto_categoria_id),
          label: cat.nome,
          selected: selectedCatId != null && String(cat.produto_categoria_id) === String(selectedCatId)
        };
      });
    },

    buildPrintChoices(selectedPrintId){
      return this.dispositivos.map(function(disp){
        return {
          value: String(disp.id),
          label: disp.nome,
          selected: selectedPrintId != null && String(disp.id) === String(selectedPrintId)
        };
      });
    },

    initChoices(selectedCatId, selectedPrintId){
      var element = document.getElementById("choices-category");
      if(element){
        this.ch_cate = new Choices(element, {
          searchEnabled: false,
          choices: this.buildCatChoices(selectedCatId),
          shouldSort: false
        });
        this.ch_cate.passedElement.element.addEventListener('change', (e) => {
          this.$parent.produto.categoria.produto_categoria_id = e.target.value;
        });
      }

      var elementPrint = document.getElementById("print");
      if(elementPrint){
        this.ch_print = new Choices(elementPrint, {
          searchEnabled: false,
          choices: this.buildPrintChoices(selectedPrintId),
          shouldSort: false
        });
        this.ch_print.passedElement.element.addEventListener('change', (e) => {
          this.$parent.produto.print_name = e.target.value;
        });
      }
    },

    setSelectedValues(produto){
      if(!produto) return;

      this.pendingProduto = produto;

      if(this.dataReady){
        this.applyPendingProduto();
      }
    },

    applyPendingProduto(){
      if(!this.pendingProduto) return;

      var selectedCatId = null;
      var selectedPrintId = null;

      if(this.pendingProduto.categoria && this.pendingProduto.categoria.produto_categoria_id != null){
        selectedCatId = this.pendingProduto.categoria.produto_categoria_id;
      }
      selectedPrintId = this.pendingProduto.print_name;

      // Usa setChoices para trocar as opções sem destruir o Choices
      if(this.ch_cate){
        this.ch_cate.clearStore();
        this.ch_cate.setChoices(this.buildCatChoices(selectedCatId), 'value', 'label', true);
      }

      if(this.ch_print){
        this.ch_print.clearStore();
        this.ch_print.setChoices(this.buildPrintChoices(selectedPrintId), 'value', 'label', true);
      }

      var qlEditor = document.getElementsByClassName("ql-editor")[0];
      if(qlEditor && this.pendingProduto.descricao){
        qlEditor.innerHTML = this.pendingProduto.descricao;
      }

      this.pendingProduto = null;
    },

    async init() {
      var resp = await store.dispatch('getCategoriaSelect',{});
      this.categorias = resp.data.dados
      var resp_dis = await store.dispatch('getDispositivoSelect',{});
      this.dispositivos = resp_dis.data.dados

      this.dataReady = true;

      if(this.pendingProduto){
        // Produto já carregou antes das categorias - cria Choices com seleção correta
        var selectedCatId = null;
        var selectedPrintId = null;
        if(this.pendingProduto.categoria && this.pendingProduto.categoria.produto_categoria_id != null){
          selectedCatId = this.pendingProduto.categoria.produto_categoria_id;
        }
        selectedPrintId = this.pendingProduto.print_name;
        this.initChoices(selectedCatId, selectedPrintId);

        var qlEditor = document.getElementsByClassName("ql-editor")[0];
        if(qlEditor && this.pendingProduto.descricao){
          qlEditor.innerHTML = this.pendingProduto.descricao;
        }
        this.pendingProduto = null;
      } else {
        // Produto novo - cria Choices sem seleção
        this.initChoices(null, null);
      }
    },

  },

};
</script>
